import { render, staticRenderFns } from "./ShowsList.vue?vue&type=template&id=5c9a088b&"
import script from "./ShowsList.vue?vue&type=script&lang=js&"
export * from "./ShowsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports